export default {
  name: 'relajante-facial',
  label: 'relajante facial',
  formula: [
    {
      name: 'aceite esencial ylang ylang',
      quantity: 2.5,
      unit: 'ml',
      ref: 'ylang-ylang'
    },
    {
      name: 'aceite esencial sándalo',
      quantity: 7,
      unit: 'ml',
      ref: 'sandalo'
    },
    {
      name: 'aceite esencial lavanda',
      quantity: 7.5,
      unit: 'ml',
      ref: 'lavanda'
    },
    {
      name: 'aceite avellana',
      quantity: 5,
      unit: 'ml',
      ref: 'avellana'
    },
  ],
  recipes: [
    {
      name: 'crema relajante facial',
      ingredients: [
        {
          name: 'crema de almendras dulces',
          quantity: 15,
          unit: 'ml',
          ref: 'almendras-dulces'
        },
        {
          name: 'sinergia relajante facial',
          quantity: 2.5,
          unit: 'ml'
        },
      ]
    },
    {
      name: 'aceite relajante facial',
      ingredients: [
        {
          name: 'aceite almendras dulces',
          quantity: 15,
          unit: 'ml',
          ref: 'almendras-dulces'
        },
        {
          name: 'aceite de aguacate',
          quantity: 7.5,
          unit: 'ml',
          ref: 'aguacate'
        },
        {
          name: 'aceite de olivo',
          quantity: 7.5,
          unit: 'ml',
          ref: 'olivo'
        },
        {
          name: 'sinergia relajante facial',
          quantity: 2.5,
          unit: 'ml',
        },
      ]
    },
    {
      name: 'aceite relajante facial piel seca y reseca',
      ingredients: [
        {
          name: 'aceite almendras dulces',
          quantity: 15,
          unit: 'ml',
          ref: 'almendras-dulces'
        },
        {
          name: 'aceite de aguacate',
          quantity: 7.5,
          unit: 'ml',
          ref: 'aguacate'
        },
        {
          name: 'aceite de olivo',
          quantity: 7.5,
          unit: 'ml',
          ref: 'olivo'
        },
        {
          name: 'aceite esencial sándalo',
          quantity: 4,
          unit: 'ml',
          ref: 'sandalo'
        },
        {
          name: 'sinergia relajante facial',
          quantity: 2.5,
          unit: 'ml',
        },
      ]
    },
    {
      name: 'aceite base',
      ingredients: [
        {
          name: 'aceite almendras dulces',
          quantity: 15,
          unit: 'ml',
          ref: 'almendras-dulces'
        },
        {
          name: 'aceite de aguacate',
          quantity: 7.5,
          unit: 'ml',
          ref: 'aguacate'
        },
        {
          name: 'aceite de olivo',
          quantity: 7.5,
          unit: 'ml',
          ref: 'olivo'
        },
      ]
    },
    {
      name: 'loción facial relajante',
      ingredients: [
        {
          name: 'té de manzanilla',
          quantity: 15,
          unit: 'ml'
        },
        {
          name: 'tequila',
          quantity: 30,
          unit: 'ml'
        },
        {
          name: 'sinergia facial relajante',
          quantity: 1.25,
          unit: 'ml'
        },
      ]
    },
    {
      name: 'agua de uso facial relajante',
      ingredients: [
        {
          name: 'té de manzanilla',
          quantity: 15,
          unit: 'ml'
        },
        {
          name: 'aceite de avellanas',
          quantity: 1.5,
          unit: 'ml',
          ref: 'avellana'
        },
        {
          name: 'sinergia facial relajante',
          quantity: 0.8,
          unit: 'ml'
        },
      ]
    },
  ]
}
